module.exports = __webpack_public_path__ + "img/nexcess-logo-icon.2dae9d20.svg";